module.exports = __webpack_public_path__ + "img/lift5.1fce9f93.jpg";